export default "__VITE_ASSET__DaspGzDV__"